import { useContext, useEffect, useState } from "react";
import { Context } from "../context/MainContext";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { fetchOrder } from "../api/adminApi";
import Loading from "../components/Loading";
import UpdateOrderStatus from "../components/UpdateOrderStatus";
import placeholder from "../assets/images/product-placeholder.png";

const OrderItemDB = () => {
  const { user } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const formattingOption = {
    style: "currency",
    currency: "NGN",
    minimumFractionDigits: 2,
  };

  const { id } = useParams();

  useEffect(() => {
    const handleFetchOrder = async () => {
      if (user?.id) {
        setLoading(true);
        try {
          const res = await fetchOrder(user?.accessToken, id);

          setOrder(res.data);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          const message =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
          toast.error(message);
        }
      }
    };

    handleFetchOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, user?.accessToken, refresh]);

  return (
    <div className="blog__main">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="checkout__right">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 20,
                flexWrap: "wrap",
              }}
            >
              <h2>
                Order (Status:{" "}
                <span style={{ color: "#1c64a2" }}>{order?.status}</span>)
              </h2>
              <UpdateOrderStatus
                currentStatus={order?.status}
                id={order?.id}
                setRefresh={setRefresh}
              />
            </div>

            <div className="cart__main__total" style={{ marginTop: 30 }}>
              <div className="cart__main__total__part">
                <b>Products</b>
              </div>
              {order?.items?.map((product) => {
                return (
                  <div key={product.id} className="cart__main__total__part">
                    <span>
                      <img
                        style={{ width: 100, marginRight: 10 }}
                        src={
                          // product?.imgMain
                          process.env.REACT_APP_API_URL +
                          product?.product?.imgMain
                          // : placeholder
                        }
                        alt=""
                      />{" "}
                      {product?.name} <b>× {product?.quantity}</b>{" "}
                    </span>
                    {(product?.price * product?.quantity).toLocaleString(
                      "en-NG",
                      formattingOption,
                    )}
                  </div>
                );
              })}

              <div className="cart__main__total__part">
                <b>Date</b>
                {order?.createdAt?.slice(0, 10)}
              </div>
              <div className="cart__main__total__part">
                <b>Order/Payment Id (Paypal)</b>
                {order?.paymentId}
              </div>
              <div className="cart__main__total__part">
                <b>Payment Status</b>
                <p
                  className={`cart__main__total__part__status ${
                    order?.paymentStatus === "Success"
                      ? "status--success"
                      : order?.paymentStatus === "Failed"
                        ? "status--failed"
                        : "status--initiated"
                  }`}
                >
                  {order?.paymentStatus === "Initiated"
                    ? "Pending"
                    : order?.paymentStatus}
                </p>
                {/* <p></p>{order?.paymentStatus} */}
              </div>
              <div className="cart__main__total__part">
                <b>User Id</b>
                {order?.userId}
              </div>
              <div className="cart__main__total__part">
                <b>orderNote</b>
                {order?.orderNote}
              </div>
              <div className="cart__main__total__part">
                <b>Shipping Method</b>
                {order?.shippingMethod}
              </div>
              <div className="cart__main__total__part">
                <b>Shipping Amount</b>
                {order?.shippingAmount?.toLocaleString(
                  "en-NG",
                  formattingOption,
                )}
              </div>

              <div className="cart__main__total__part">
                <b>Total</b>
                <b>{order?.bill?.toLocaleString("en-NG", formattingOption)}</b>
              </div>
            </div>
          </div>

          <div className="checkout__right" style={{ marginTop: 50 }}>
            <h3>Shipping details</h3>

            <div className="cart__main__total" style={{ margin: "30px 0" }}>
              <div className="cart__main__total__part">
                <b>User Id</b>
                {order?.billingAddress?.userId}
              </div>
              <div className="cart__main__total__part">
                <b>First name</b>
                {order?.billingAddress?.firstName}
              </div>
              <div className="cart__main__total__part">
                <b>Last name</b>
                {order?.billingAddress?.lastName}
              </div>
              <div className="cart__main__total__part">
                <b>Company name </b>
                {order?.billingAddress?.companyName}
              </div>
              <div className="cart__main__total__part">
                <b>Country</b>
                {order?.billingAddress?.country}
              </div>
              <div className="cart__main__total__part">
                <b>Street address</b>
                {order?.billingAddress?.streetAddress}
              </div>

              <div className="cart__main__total__part">
                <b>Street address 2</b>
                {order?.billingAddress?.streetAddressOpt}
              </div>
              <div className="cart__main__total__part">
                <b>Town / City</b>
                {order?.billingAddress?.city}
              </div>
              <div className="cart__main__total__part">
                <b>State</b>
                {order?.billingAddress?.state}
              </div>
              <div className="cart__main__total__part">
                <b>ZIP Code</b>
                {order?.billingAddress?.zipCode}
              </div>
              <div className="cart__main__total__part">
                <b>Phone</b>
                {order?.billingAddress?.phone}
              </div>
              <div className="cart__main__total__part">
                <b>Email address</b>
                {order?.billingAddress?.email}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderItemDB;
